import * as React from "react";
import { DateTimeFormat } from "@ova-studio/react-hyper-admin";
import { DateTime } from "luxon";
const searchTypes = {
    posts: {
        icon: 'file-document-check-outline',
        name: 'Опубліковані',
        allowCheck: (app) => app.auth.can('posts.public::view'),
        render: ({ data }) => {
            var _a;
            return (React.createElement(React.Fragment, null,
                React.createElement("b", null, data.title),
                React.createElement("span", { className: 'ms-auto text-muted small' },
                    React.createElement(DateTimeFormat, { dt: data.publish_dt, children: dt => dt.toLocaleString(DateTime.DATETIME_SHORT) })),
                data.author && (React.createElement("span", { className: 'ms-1 text-muted small' },
                    React.createElement("i", { className: 'mdi mdi-account' }),
                    ' ', (_a = data.author) === null || _a === void 0 ? void 0 :
                    _a.name))));
        },
    },
    drafts: {
        icon: 'file-document-edit',
        name: 'Чернетки',
        allowCheck: (app) => app.auth.canAny(['posts.drafts::all', 'posts.drafts::create']),
        render: ({ data }) => {
            var _a;
            return (React.createElement(React.Fragment, null,
                React.createElement("b", null, data.title),
                React.createElement("span", { className: 'ms-auto text-muted small' },
                    React.createElement(DateTimeFormat, { dt: data.publish_dt, children: dt => dt.toLocaleString(DateTime.DATETIME_SHORT) })),
                data.author && (React.createElement("span", { className: 'ms-1 text-muted small' },
                    React.createElement("i", { className: 'mdi mdi-account' }),
                    ' ', (_a = data.author) === null || _a === void 0 ? void 0 :
                    _a.name))));
        },
    },
    pools: {
        icon: 'poll',
        name: 'Опитування',
        allowCheck: (app) => app.auth.can('pools::all'),
        render: ({ data }) => (React.createElement(React.Fragment, null,
            React.createElement("b", null, data.txt),
            React.createElement("span", { className: 'ms-auto text-muted small' },
                React.createElement(DateTimeFormat, { dt: data.created_at, children: dt => dt.toLocaleString(DateTime.DATETIME_SHORT) })))),
    },
    notices: {
        icon: 'bulletin-board',
        name: 'Оголошення',
        allowCheck: (app) => app.auth.can('notices::manage'),
        render: ({ data }) => (React.createElement(React.Fragment, null,
            React.createElement("b", null, data.title),
            React.createElement("span", { className: 'ms-auto text-muted small' },
                React.createElement(DateTimeFormat, { dt: data.publish_dt, children: dt => dt.toLocaleString(DateTime.DATETIME_SHORT) })))),
    },
    categories: {
        icon: 'book-open-variant',
        name: 'Категорії',
        allowCheck: (app) => app.auth.can('terms.categories::manage'),
    },
    tags: {
        icon: 'tag',
        name: 'Теги',
        allowCheck: (app) => app.auth.can('terms.tags::manage'),
    },
    pages: {
        icon: 'file-document',
        name: 'Сторінки',
        allowCheck: (app) => app.auth.can('pages.static::manage'),
    },
    users: {
        icon: 'account',
        name: 'Користувачі адмінпанелі',
        allowCheck: (app) => app.auth.can('settings.users::manage'),
    },
    // ['site-users']: {
    //     icon: 'account-card-outline',
    //     name: 'Користувачі порталу',
    //     allowCheck: (app) => app.auth.can('settings.site-users::manage'),
    // },
};
export default searchTypes;
//# sourceMappingURL=searchTypes.js.map